import { defineMessages } from 'react-intl';

export default defineMessages({
  judgementAddPronouncingTitle: {
    id: 'legal_proceeding_page.judgement_add.judgement_add_pronouncing.title',
  },
  judgementAddIncomeCertificateTitle: {
    id: 'legal_proceeding_page.judgement_add.income_certificate.title',
  },
  selectVictims: {
    id: 'legal_proceeding_page.judgement_add.income_certificate.victim_title',
  },
  submitForm: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.form.submit',
  },
  income: {
    id: 'legal_proceeding_page.judgement_add.income_certificate.income',
  },

  judgementAddIncomeCertificateSubtitle: {
    id: 'legal_proceeding_page.judgement_add.income_certificate.subtitle',
  },
  judgementAddPronouncingSubtitle: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.subtitle',
  },
  judgementAddPronouncingButtonTitle: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.add_judgement_button_title',
  },
  expertiseTitle: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.form.expertise.form.expertise_title',
  },
  expertisesSectionTitle: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.form.expertise.form.expertises_title',
  },
  addExpertise: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.form.expertise.form.add_expertise',
  },
  deleteExpertise: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.form.expertise.form.delete_expertise',
  },
  addNewAddDocument: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.add_new_add',
  },
  addNewAddDocumentAppeal: {
    id: 'legal_proceeding_page.appeal_add.appeal_add_pronouncing.add_new_add',
  },
  appealAddPronouncingTitle: {
    id: 'legal_proceeding_page.appeal_add_pronouncing_title',
  },
  incomeCertificateSuccessMessage: {
    id: 'legal_proceeding_page.judgement_add.income_certificate.toast_success',
  },
  cancelForm: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.form.cancel',
  },
  typeDocument: {
    id: 'manager_home_page.last_assigned_claims_table_fields.type',
  },
});
